var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"text-center my-3 color-primary"},[_vm._v("Employee Dashboard")])])}]

export { render, staticRenderFns }